<template>
  <panel-browser
    title="Alerts"
    :searchEnabled="false"
    :tabsEnabled="false"
    class="explorer-panel">

    <template slot="heading">
      <div class="level panel-heading pagination">
        <div class="level-left">
          <svgicon
            @click="reset()"
            class="level-item is-clickable"
            name="refresh"
            width="30"
            height="30"
            color="#C4FFF9">
          </svgicon>
          <p class="level-item is-size-5 heading">Alerts</p>
        </div>
        <div class="level-right" v-if="alertItems.length > 0">
          <pagination
            :next="hasNext"
            :prev="hasPrev"
            :nextClick="nextPage"
            :prevClick="prevPage"
            :page="page"
            :perPage="perPage"
            :itemCount="itemCount"
            :total="total"
            :loading="loading">
          </pagination>
        </div>
      </div>
    </template>

    <alert-log-panel-item
      v-for="(alert,index) in alertItems"
      :key="alert.id"
      :item="alert"
      :related="alert.parsed.related"
      @selectedPanelItem="selectIndex(index)">
    </alert-log-panel-item>

    <div slot="right" class="editor">
      <content-nav-bar>
        <alert-log-filter-bar
          ref="filterBar"
          :asset="asset"
          tagsEndpoint="primary/listAlertsTags"
          storeName="alertViewState"></alert-log-filter-bar>
      </content-nav-bar>
      <alert
        v-if="selectedAlert"
        :alert="selectedAlert"></alert>
      <!-- <transition name="fade" mode="out-in">
        <router-view :log="selectedLog"></router-view>
      </transition> -->
    </div>
  </panel-browser>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import pagination from '@/mixins/pagination';
import PanelBrowser from '@/components/PanelBrowser.vue';
import Pagination from '@/components/Pagination.vue';
import AlertLogPanelItem from '@/components/alertlogs/AlertLogPanelItem.vue';
import Alert from '@/views/alerts/Alert.vue';
import AlertLogFilterBar from '@/components/alertlogs/AlertLogFilterBar.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'Alerts',
  mixins: [pagination],
  components: {
    PanelBrowser,
    AlertLogPanelItem,
    Pagination,
    Alert,
    AlertLogFilterBar,
    ContentNavBar,
  },
  props: {
    asset: {
      type: Object,
      default: null,
    },
  },
  async mounted() {
    this.query = this.$route.query.q || [];
    if (this.query.length > 0) {
      this.$store.commit('alertViewState/CLEAR_FILTER');
      if (typeof this.query === 'object') {
        this.query.forEach((item) => {
          this.$refs.filterBar.addRawFilter(item);
        });
      } else if (typeof this.query === 'string') {
        this.$refs.filterBar.addRawFilter(this.query);
      }
    }
    this.refresh(null);
  },
  data() {
    return {
      selectedIndex: 0,
      endpoint: 'primary/listAlerts',
      alertItems: [],
      query: null,
    };
  },
  watch: {
    filter() {
      this.reset();
    },
    items() {
      this.alertItems = _.map(this.items, (alert) => {
        const o = Object.assign({}, alert);
        o.parsed = JSON.parse(alert.alert);
        o.selected = false;
        return o;
      });

      // Select the first item if there is one
      if (this.items.length > 0) {
        this.selectIndex(0);
      }
    },
  },
  computed: {
    ...mapState('alertViewState', ['filterList']),
    selectedAlertTitle() {
      return this.getName(this.selectedAlert);
    },
    selectedAlert() {
      if (this.alertItems && this.alertItems.length > 0) {
        return this.alertItems[this.selectedIndex];
      }
      return null;
    },
    requestVars() {
      return {
        uuid: this.asset ? this.asset.uuid : null,
        filter: this.filter,
      };
    },
    filter() {
      const filter = {
        filters: [],
        operator: 'and',
      };
      this.filterList.forEach((f) => {
        const filterItem = f.split(':');
        if (filterItem[0] === 'tag') {
          filter.filters.push({
            alert: {
              json: JSON.stringify({
                match: {
                  tags: [filterItem[1]],
                },
              }),
            },
          });
        } else if (filterItem[0] === 'eventType') {
          filter.filters.push({
            alert: {
              json: JSON.stringify({
                eventType: filterItem[1],
              }),
            },
          });
        } else if (filterItem[0] === 'action') {
          filter.filters.push({
            alert: {
              json: JSON.stringify({
                match: {
                  actions: [filterItem[1]],
                },
              }),
            },
          });
        }
      });
      if (Object.keys(filter.filters).length > 0) {
        return filter;
      }
      return filter;
    },
  },
  methods: {
    selectIndex(index) {
      if (this.alertItems.length > 0) {
        this.alertItems[this.selectedIndex].selected = false;
        this.alertItems[index].selected = true;
        this.selectedIndex = index;
        // eslint-disable-next-line
        // this.$router.push({ name: 'logs.index.log.detail', params: { id: this.alertItems[index].uuid } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.explorer-panel {
  .heading {
    color: $font-color;
    margin: 0;
  }

  .left {
    border-right: 1px solid $border-color;
  }

  .pagination {
    margin: 0;

    a {
      color: whitesmoke;
    }

    a.inactive {
      cursor: default;
      color: #777;
    }
  }

  .page-arrow {
    font-size: 1.2rem;
    background: none;
    margin: 0;
  }

  .page-num {
    font-size: .85rem;
    color: $expression-background;
    margin: 0;
  }
}

.tabs {
  margin-bottom: 0;
}

.editor {
  width: 100%;
  height: 100%;
}
</style>
